"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationHeader = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const react_1 = tslib_1.__importStar(require("react"));
const ui_1 = require("@grafana/ui");
const OperationInfoButton_1 = require("./OperationInfoButton");
const FlexItem_1 = require("../../QueryEditor/FlexItem");
exports.OperationHeader = react_1.default.memo(({ operation, definition, index, onChange, onRemove, onToggle, queryModeller, dragHandleProps }) => {
    var _a;
    const styles = (0, ui_1.useStyles2)(getStyles);
    const [state, setState] = (0, react_1.useState)({});
    const onToggleSwitcher = () => {
        if (state.isOpen) {
            setState(Object.assign(Object.assign({}, state), { isOpen: false }));
        }
        else {
            const alternatives = queryModeller
                .getAlternativeOperations(definition.alternativesKey)
                .map((alt) => ({ label: alt.name, value: alt }));
            setState({ isOpen: true, alternatives });
        }
    };
    return (react_1.default.createElement("div", { className: styles.header },
        !state.isOpen && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", Object.assign({}, dragHandleProps), (_a = definition.name) !== null && _a !== void 0 ? _a : definition.id),
            react_1.default.createElement(FlexItem_1.FlexItem, { grow: 1 }),
            react_1.default.createElement("div", { className: `${styles.operationHeaderButtons} operation-header-show-on-hover` },
                react_1.default.createElement(ui_1.Button, { icon: "angle-down", size: "sm", onClick: onToggleSwitcher, fill: "text", variant: "secondary", title: "Click to view alternative operations" }),
                react_1.default.createElement(OperationInfoButton_1.OperationInfoButton, { definition: definition, operation: operation, innerQueryPlaceholder: queryModeller.innerQueryPlaceholder }),
                definition.toggleable && (react_1.default.createElement(ui_1.Button, { icon: operation.disabled ? "eye-slash" : "eye", size: "sm", onClick: () => onToggle(index), fill: "text", variant: "secondary", title: operation.disabled ? "Enable operation" : "Disable operation" })),
                react_1.default.createElement(ui_1.Button, { icon: "times", size: "sm", onClick: () => onRemove(index), fill: "text", variant: "secondary", title: "Remove operation" })))),
        state.isOpen && (react_1.default.createElement("div", { className: styles.selectWrapper },
            react_1.default.createElement(ui_1.Select, { autoFocus: true, openMenuOnFocus: true, placeholder: "Replace with", options: state.alternatives, isOpen: true, onCloseMenu: onToggleSwitcher, onChange: (value) => {
                    if (value.value) {
                        // Operation should exist if it is selectable
                        const newDef = queryModeller.getOperationDefinition(value.value.id);
                        // copy default params, and override with all current params
                        const newParams = [...newDef.defaultParams];
                        for (let i = 0; i < Math.min(operation.params.length, newParams.length); i++) {
                            if (newDef.params[i].type === definition.params[i].type) {
                                newParams[i] = operation.params[i];
                            }
                        }
                        const changedOp = Object.assign(Object.assign({}, operation), { params: newParams, id: value.value.id });
                        onChange(index, definition.changeTypeHandler ? definition.changeTypeHandler(changedOp, newDef) : changedOp);
                    }
                } })))));
});
exports.OperationHeader.displayName = 'OperationHeader';
const getStyles = (theme) => {
    return {
        header: (0, css_1.css)({
            borderBottom: `1px solid ${theme.colors.border.medium}`,
            padding: theme.spacing(0.5, 0.5, 0.5, 1),
            display: 'flex',
            alignItems: 'center',
        }),
        operationHeaderButtons: (0, css_1.css)({
            opacity: 1,
        }),
        selectWrapper: (0, css_1.css)({
            paddingRight: theme.spacing(2),
        }),
    };
};
//# sourceMappingURL=OperationHeader.js.map